import React, { createContext, useContext, useMemo } from 'react'

const GedcomDataContext = createContext()

/**
 *
 * @returns {{gedcomData: import('../services/getGedcomData').GedcomData | undefined; refetchGedcomData: Function}}
 */

export const useGedcomData = () => {
  const context = useContext(GedcomDataContext)
  if (!context) throw new Error('You need to use the GedcomDataProvider to use useGedcomData')
  return context
}

/**
 *
 * @param {{gedcomData: import('../services/getGedcomData').GedcomData | undefined; refetchGedcomData: Function}} props
 * @returns {JSX.Element}
 */

export default function GedcomDataProvider({ gedcomData, refetchGedcomData, children }) {
  const value = useMemo(() => ({ gedcomData, refetchGedcomData }), [gedcomData, refetchGedcomData])
  return <GedcomDataContext.Provider value={value}>{children}</GedcomDataContext.Provider>
}
